import * as React from "react";

type Theme = "light" | "dark";
const KEY = "poji-admin-theme";

function initial(): Theme {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    /* depolama kapalı */
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Açık/koyu tema (kişisel tercih, tarayıcıda saklanır) */
export function useTheme() {
  const [theme, setTheme] = React.useState<Theme>(() =>
    document.documentElement.classList.contains("dark") ? "dark" : "light",
  );
  const toggle = React.useCallback(() => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    applyTheme(next);
    setTheme(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* depolama kapalı */
    }
  }, [theme]);
  return { theme, toggle };
}

export function applyTheme(t: Theme = initial()) {
  document.documentElement.classList.toggle("dark", t === "dark");
}
